module.exports = __webpack_public_path__ + "static/media/im.40fd4058.svg";